import React from "react";
import { createUseStyles } from "react-jss";
import { variables } from "../../variables";
const AccEngineStyles = createUseStyles({
  AccEngine: {
    display: "grid",
    overflow: "hidden",
    placeContent: "center",
    textAlign: "center",
  },
  title: {
    display: "grid",
    textAlign: "center",
    height: "100%",
    alignItems: "end",
    padding: variables.normal_gap,
  },
});
const AccEngine = () => {
  const classes = AccEngineStyles();
  return (
    <div className={classes.AccEngine}>
      <div className={classes.title}>
        <h1>Acc Engine</h1>
      </div>
    </div>
  );
};

export default AccEngine;
